import axios from 'axios';

// Create a dedicated connection instance
const api = axios.create({
    baseURL: 'https://bouncepen.com/api',
    headers: {
        'Content-Type': 'application/json'
    }
});

// INTERCEPTOR: Before sending any request, attach the token
api.interceptors.request.use(
    (config) => {
        // FIX: Check both storage keys to ensure we find the token
        const token = localStorage.getItem('authToken') || localStorage.getItem('token');
        
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;